export interface CodeMap {
  id: number
  category: string
  precedence: number
  name: string
  value: string
  enable: boolean
  reserve1: string | null
  reserve2: string | null
}

export enum CodeMapCategory {
  ListCodeMapCategory = 'list_codeMap_category',
  ListOtpVerifyMethod = 'list_otp_verify_method',
  SystemParams = 'system_params',
}

export enum CodeMapTokenWithLocate {
  Mobile = 'mobile',
  Admin = 'admin',
}
